import { Component } from '@angular/core';
import { AbstractFormComponent } from '../abstract-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogActions, MatDialogContent } from '@angular/material/dialog';
import { FormActionButtonsComponent } from '../../components/form-action-buttons/form-action-buttons.component';

@Component({
  selector: 'logpn-form-modal',
  templateUrl: './form-modal.component.html',
  styleUrl: './form-modal.component.scss',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatDialogContent,
    MatDialogActions,
    FormActionButtonsComponent,
  ],
})
export class FormModalComponent extends AbstractFormComponent {}
